import { createContext, Dispatch, ReactNode, useContext, useState } from "react"

interface EventContextInterface {
  value: string[]
  setValue: Dispatch<React.SetStateAction<string[]>>
  searchVal: string
  setSearchVal: Dispatch<React.SetStateAction<string>>
  searchActive: boolean
  setSearchActive: Dispatch<React.SetStateAction<boolean>>
  petFriendlyFilter: string
  setPetFriendlyFilter: Dispatch<React.SetStateAction<string>>
  ageRangeFilter: string
  setAgeRangeFilter: Dispatch<React.SetStateAction<string>>
  priceFilter: string
  setPriceFilter: Dispatch<React.SetStateAction<string>>
}

export const EventContext = createContext({} as EventContextInterface)

export const EventProvider = ({ children }: { children: ReactNode }) => {
  const [value, setValue] = useState<string[]>([])
  const [searchVal, setSearchVal] = useState("")
  const [searchActive, setSearchActive] = useState(false)
  const [petFriendlyFilter, setPetFriendlyFilter] = useState("")
  const [ageRangeFilter, setAgeRangeFilter] = useState("ANY")
  const [priceFilter, setPriceFilter] = useState("Any")

  return (
    <EventContext.Provider
      value={{
        value,
        setValue,
        searchVal,
        setSearchVal,
        searchActive,
        setSearchActive,
        petFriendlyFilter,
        setPetFriendlyFilter,
        ageRangeFilter,
        setAgeRangeFilter,
        priceFilter,
        setPriceFilter,
      }}
    >
      {children}
    </EventContext.Provider>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export function useEventContext() {
  const appContext = useContext(EventContext)
  if (appContext === undefined) {
    throw new Error("useEventContext must be used within an EventProvider")
  }
  return appContext
}
